const ResourceKeys = {
  AlertReason: "alertReasons",
  Customer: "customers",
  Department: "departments",
  FabricCategory: "fabric-categories",
  FabricPattern: "fabric-patterns",
  Product: "products",
  Supplier: "suppliers",
  Season: "seasons",
  Size: "sizes",
  Table: "tables",
  Unit: "units",
  Warehouse: "warehouses",
  Order: "orders",
  Invoice: "invoices",
  SupplierRoll: "rolls"
};

export const ResourceEntityValues = {
  alertReasons: "AlertReason",
  customers: "Customer",
  departments: "Department",
  "fabric-categories": "FabricCategory",
  "fabric-patterns": "FabricPattern",
  products: "Product",
  suppliers: "Supplier",
  seasons: "Season",
  sizes: "Size",
  tables: "Table",
  units: "Unit",
  warehouses: "Warehouse"
};

export default ResourceKeys;
